import store from '@/framework/store'
import userStore from './userStore'

const options = {
  install () {
    store.registerModule('user', userStore)
  }
}

export default options
